import React from 'react';
import { Box } from '@mui/material';

export const formatTimestamp = (timestamp: string) => {
  const parts = timestamp.split(':');

  if (parts.length === 2) {
    const minutes = parseInt(parts[0], 10);
    if (minutes < 60) {
      return `00:${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}`;
    }
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours
      .toString()
      .padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}:${
      parts[1]
    }`;
  }
  if (parts.length === 3) {
    return `${parts[0].padStart(2, '0')}:${parts[1].padStart(
      2,
      '0'
    )}:${parts[2].padStart(2, '0')}`;
  }

  return timestamp;
};

export const highlightText = (text: string, searchTerm: string) => {
  if (!searchTerm) return text;
  const regex = new RegExp(`(${searchTerm})`, 'gi');
  return text.split(regex).map((part, i) =>
    regex.test(part) ? (
      <Box
        key={i}
        component="mark"
        sx={{
          backgroundColor: 'warning.light',
          color: 'warning.contrastText',
          borderRadius: '4px',
          textDecoration: 'none',
        }}
      >
        {part}
      </Box>
    ) : (
      part
    )
  );
};
